// ** React
import { useMemo } from "react";
import { useHistory } from "react-router-dom";
// ** Redux
import { useDispatch } from "react-redux";
import { openAuthModal } from "store/modules/global-common.slice";

// ** Custom Components
import Block from "components/layout/Block";

// ** Media Type Components
import MediaImage from "./components/MediaImage";
import MediaVideo from "./components/MediaVideo";

// ** Styled Components
import {
	StyledMediaTypeContainer,
	StyledMediaTypeContainerFull,
	StyledTextWrapper,
} from "./styles";
import { StyledMediaTypeLoginContainer } from "./styles/MediaTypeLoginContainer.styled";

// #####################################################

const MediaTypeGalleryRatio4to3 = ({
	type,
	item,
	isAuth,
	size,
	to,
	userLogin,
	removePaddingOnMobile,
}) => {
	const dispatch = useDispatch();
	const history = useHistory();

	const href = useMemo(() => {
		return isAuth
			? {
					hash: to ? to.toLowerCase() : "",
					search: location?.search || "",
			  }
			: "/";
	}, [isAuth, to]);

	// #####################################################

	if (type === "post") {
		return (
			<Block mt={3}>
				<StyledTextWrapper
					removePaddingOnMobile={removePaddingOnMobile}
				>
					{userLogin}
				</StyledTextWrapper>
			</Block>
		);
	}

	return (
		<StyledMediaTypeContainerFull
			removePaddingOnMobile={removePaddingOnMobile}
		>
			<StyledMediaTypeLoginContainer zIndex={2}>
				{userLogin}
			</StyledMediaTypeLoginContainer>
			<StyledMediaTypeContainer flex justifyCenter zIndex={0}>
				<Block
					flex
					full
					onClick={() => {
						if (!isAuth) {
							dispatch(openAuthModal());
						} else {
							history.push(href);
						}
					}}
				>
					{type === "video" ? (
						<MediaVideo
							type={type}
							width={item.width}
							height={item.height}
							thumbnail={
								item.media?.thumbs.poster || item.thumbs?.poster
							}
							alt="Video in gallery"
							iconSize={size || "medium"}
							sourceFull={item.media?.video || item?.video}
							sourcePreview={
								item.media?.thumbs?.preview_vertical ||
								item.thumbs?.preview_vertical
							}
							isCover
							withRatio_4_3
						/>
					) : (
						<MediaImage
							width={item.width}
							height={item.height}
							thumbnail={item.media?.big || item.images?.big}
							alt="Photo in gallery"
							size={size || "medium"}
							isCover
							withRatio_4_3
						/>
					)}
				</Block>
			</StyledMediaTypeContainer>
		</StyledMediaTypeContainerFull>
	);
};

export default MediaTypeGalleryRatio4to3;

// #####################################################
